import { LoadingIcon } from "./styled"


const Loader = () => {
  return (
    <LoadingIcon><div></div></LoadingIcon>
  )
}

export default Loader